// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { CommonService } from 'src/app/services/common.service';

export const environment = {
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
// let webUrl = 'http://localhost:8080/iotify-web';
// let adminUrl = 'http://localhost:8090/iotify-admin/';
// // const webSocketUrl = 'ws://localhost:8080/iotify-web/dashboard';
// webUrl = 'https://remon.in/iotify-web';
// adminUrl = 'https://remon.in/iotify-admin/';
// const webSocketUrl = 'wss://remon.in/iotify-web/dashboard';



let urlsBasedhost={
  localhost:
  'http://localhost:8080/iotify-web@http://localhost:8090/iotify-admin/@ws://localhost:8080/iotify-web/dashboard',
  ems:
  'https://remon.in/iotify-web@https://remon.in/iotify-admin/@wss://remon.in/iotify-web/dashboard',
  iot:
  'https://remon.in/iotify-web@https://remon.in/iotify-admin/@wss://remon.in/iotify-web/dashboard',
  remon:
  'https://remon.in/iotify-web@https://remon.in/iotify-admin/@wss://remon.in/iotify-web/dashboard',
  omc:
'https://omcnew.remon.in/iotify-web@https://omcnew.remon.in/iotify-admin/@wss://omcnew.remon.in/iotify-web/dashboard',
// oil:
// 'http://192.168.0.126:8080/iotify-web@http://192.168.0.126:8090/iotify-admin/@ws://192.168.0.126:8080/iotify-web/dashboard',
oil:
'https://qa.remon.in/iotify-web@https://qa.remon.in/iotify-admin/@wss://qa.remon.in/iotify-web/dashboard',
};
// omc:'http://52.172.92.18:8080/iotify-web@http://52.172.92.18:8090/iotify-admin/@ws://52.172.92.18:8080/iotify-web/dashboard',
let manualSethost='oil';
let host=manualSethost||window.location.hostname.split('.')[0];
let urlsArray:string[]=urlsBasedhost[host].split('@');
console.log(urlsArray);
let webUrl =  urlsArray[0];
let adminUrl =  urlsArray[1];
let webSocketUrl =  urlsArray[2];

// const webSocketUrl = 'ws://192.168.0.113:8080/iotify-web/dashboard';
// webUrl ='http://192.168.0.113:8080/iotify-web';
// adminUrl =  'http://192.168.0.113:8090/iotify-admin/';


const adminSocketUrl = adminUrl;

export const dashboardDataSocket = {
  staticVariable: undefined,
  liveVariable: undefined,
  liveStructure: undefined,
};
 let serverUrl = {
  webUrl: webUrl,
  adminUrl: adminUrl,
  webSocketUrl: webSocketUrl,
  adminSocketUrl: adminSocketUrl,
};
// export var commonJson={
// loginDtoJson:undefined
// };
export const OnChangeApi = (companyID: any ) => {
    manualSethost = companyID;
    let host=manualSethost||window.location.hostname.split('.')[0];
    let urlsArray:string[]=urlsBasedhost[host].split('@');
    console.log(serverUrl);
    serverUrl.adminSocketUrl=  urlsArray[1]
    serverUrl.adminUrl = urlsArray[1]
    serverUrl.webSocketUrl = urlsArray[2]
    serverUrl.webUrl = urlsArray[0]
    console.log(serverUrl);
};
export {serverUrl};
